import * as types from './logSourcesActionTypes';

export default (state = [], action) => {
    switch(action.type) {
        case types.LOAD_LOG_SOURCES_FAILED:
            return [{ key: types.LOAD_LOG_SOURCES_FAILED }];
        case types.LOAD_LOG_SOURCES_SUCCESS:
            return [];
        default: 
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/log-sources/errorsReducer.js